import React, {useEffect} from 'react';
import {Route, Routes, useParams} from 'react-router';

import {Page404} from "../../404";
import {ManyOrgs} from "./many";
import {OneOrg} from "./one";
import {ManyUsers} from "./users/many";

const OneOrgRoute = () => { const {resid} = useParams(); return <OneOrg orgid={resid} />; };
const ManyUsersRoute = () => { const {resid} = useParams(); return <ManyUsers orgId={resid} />; };

const OrgsPage = () => {
    useEffect(() => {
        console.log("Orgs page");
    }, [])

    return <Routes>
        <Route path="/" element={<ManyOrgs />} />
        <Route path="/:resid" element={<OneOrgRoute />} />
        <Route path="/:resid/users" element={<ManyUsersRoute />} />
        <Route path="*" element={<Page404 />} />
    </Routes>
}

export {OrgsPage};
